import React from "react";
import PropTypes from "prop-types";
import "./css/quickReply.css";

const QuickReply = ({ addButtonResponse, reply }) => {
  const answerQuickReply = (payload, title) => {
    addButtonResponse(payload, title);
  };

  return (
    <div data-quid="quick-reply" className="quick-replies">
      <ul>
        {reply.suggestions.map((thisReply, index) => (
          <li key={index} className="quick-replies__reply">
            <button
              data-quid={`quick-reply-${reply.template}-${index}`}
              type="button"
              onClick={() => answerQuickReply(thisReply, thisReply)}
            >
              {thisReply}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

QuickReply.propTypes = {
  reply: PropTypes.shape({
    author: PropTypes.string,
    message: PropTypes.string,
    suggestions: PropTypes.array
  }).isRequired,
  addButtonResponse: PropTypes.func.isRequired
};

export default QuickReply;
